import { render, staticRenderFns } from "./ProposalDetails.vue?vue&type=template&id=e3380a74&"
import script from "./ProposalDetails.vue?vue&type=script&lang=js&"
export * from "./ProposalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports